import { createAsyncThunk } from '@reduxjs/toolkit';

import { instance } from '../../shared/services/app/instance';
import { setToken } from '../../shared/services/app/instance';

import * as toasty from '../../shared/toastify/toastify';
import { RootState } from '../store';

import {
  AnxietyType,
  QuestionPayload,
  QuestionResponse,
  AnxietyTypeRequest,
} from './screening.interface';

interface ThunkError {
  message: string;
}

export const fetchAnxietyTypes = createAsyncThunk<
  AnxietyType[],
  void,
  { rejectValue: string; state: RootState }
>('screening/fetch/anxiety/types', async (_, thunkApi) => {
  const state = thunkApi.getState();
  const token = state.auth.token;

  setToken(token);

  try {
    const response = await instance.get<AnxietyType[]>('/anxiety/types');
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Unknown error';
    return thunkApi.rejectWithValue(message);
  }
});

export const addAnxietyType = createAsyncThunk<
  AnxietyType,
  AnxietyTypeRequest,
  { rejectValue: string; state: RootState }
>('screening/add/anxiety/type', async (payload, thunkApi) => {
  try {
    const response = await instance.post<AnxietyType>(
      '/anxiety/types',
      payload
    );
    toasty.toastSuccess('Creating successfully');
    return response.data;
  } catch (error: any) {
    toasty.toastError(error?.response?.data?.message?.toLowerCase() ?? 'Error');
    return thunkApi.rejectWithValue(
      error?.response?.data?.message ?? 'Unknown error'
    );
  }
});

export const addAnxietyQuestion = createAsyncThunk<
  QuestionResponse,
  QuestionPayload,
  { rejectValue: string; state: RootState }
>('screening/add/question', async (payload, thunkApi) => {
  const state = thunkApi.getState();
  const token = state.auth.token;

  setToken(token);

  console.log(payload, 'question');

  try {
    const response = await instance.post<QuestionResponse>(
      '/anxiety/questions',
      payload
    );
    toasty.toastSuccess('Creating successfully');
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Unknown error';

    toasty.toastError(message ?? 'Error');

    console.log(error?.response, 'addAnxietyQuestion');
    return thunkApi.rejectWithValue(message);
  }
});

export const updateAnxietyType = createAsyncThunk<
  AnxietyType,
  { id: string; payload: AnxietyTypeRequest },
  { rejectValue: string; state: RootState }
>('screening/update/anxiety/type', async ({ id, payload }, thunkApi) => {
  try {
    const response = await instance.put<AnxietyType>(
      `/anxiety/types/${id}`,
      payload
    );
    toasty.toastSuccess('Updated successfully');
    return response.data;
  } catch (error: any) {
    toasty.toastError(error?.response?.data?.message?.toLowerCase() ?? 'Error');
    return thunkApi.rejectWithValue(
      error?.response?.data?.message ?? 'Unknown error'
    );
  }
});

export const deleteAnxietyType = createAsyncThunk<
  string,
  string,
  { rejectValue: string; state: RootState }
>('screening/delete/anxiety/type', async (id, thunkApi) => {
  try {
    await instance.delete(`/anxiety/types/${id}`);
    toasty.toastSuccess('Deleted successfully');
    return id;
  } catch (error: any) {
    toasty.toastError(error?.response?.data?.message?.toLowerCase() ?? 'Error');
    return thunkApi.rejectWithValue(
      error?.response?.data?.message ?? 'Unknown error'
    );
  }
});

export const fetchAnxietyQuestions = createAsyncThunk<
  QuestionResponse[],
  void,
  { rejectValue: string; state: RootState }
>('screening/fetch/questions', async (_, thunkApi) => {
  const state = thunkApi.getState();
  const token = state.auth.token;
  setToken(token);

  try {
    const response = await instance.get<QuestionResponse[]>('/anxiety/questions');
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Unknown error';
    return thunkApi.rejectWithValue(message);
  }
});

export const updateAnxietyQuestion = createAsyncThunk<
  QuestionResponse,
  { id: string; payload: QuestionPayload },
  { rejectValue: string; state: RootState }
>('screening/update/question', async ({ id, payload }, thunkApi) => {
  try {
    const response = await instance.put<QuestionResponse>(
      `/anxiety/questions/${id}`,
      payload
    );
    toasty.toastSuccess('Updated successfully');
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Unknown error';
    toasty.toastError(message ?? 'Error');
    return thunkApi.rejectWithValue(message);
  }
});

export const deleteAnxietyQuestion = createAsyncThunk<
  string,
  string,
  { rejectValue: string; state: RootState }
>('screening/delete/question', async (id, thunkApi) => {
  try {
    await instance.delete(`/anxiety/questions/${id}`);
    toasty.toastSuccess('Deleted successfully');
    return id;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Unknown error';
    toasty.toastError(message ?? 'Error');
    return thunkApi.rejectWithValue(message);
  }
});

const screeningOperations = {
  fetchAnxietyTypes,
  addAnxietyType,
  updateAnxietyType,
  deleteAnxietyType,
  fetchAnxietyQuestions,
  addAnxietyQuestion,
  updateAnxietyQuestion,
  deleteAnxietyQuestion,
};

export default screeningOperations;
